<template>
    <div class="contact-feature">
        <img class="contact-img"
            src="https://mdn.alipayobjects.com/fecodex_image/afts/img/fUJ6T7F4ESsAAAAAVgAAAAgAejH3AQBr/original" alt="">
        <div class="content">
            <div class="content-title">承接范围</div>
            <div class="warp">
                <div class="warp-item">
                    <img src="https://mdn.alipayobjects.com/fecodex_image/afts/img/PK2RR43-bWEAAAAAHhAAAAgAejH3AQBr/original"
                        class="content-icon" />
                    <div class="warp-item-text">专业门头店铺设计</div>
                </div>
                <div class="warp-item">
                    <img src="https://mdn.alipayobjects.com/fecodex_image/afts/img/PK2RR43-bWEAAAAAHhAAAAgAejH3AQBr/original"
                        class="content-icon" />
                    <div class="warp-item-text">纯设计公司</div>
                </div>
                <div class="warp-item">
                    <img src="https://mdn.alipayobjects.com/fecodex_image/afts/img/PK2RR43-bWEAAAAAHhAAAAgAejH3AQBr/original"
                        class="content-icon" />
                    <div class="warp-item-text">全国均可设计</div>
                </div>
                <div class="warp-item">
                    <img src="https://mdn.alipayobjects.com/fecodex_image/afts/img/PK2RR43-bWEAAAAAHhAAAAgAejH3AQBr/original"
                        class="content-icon" />
                    <div class="warp-item-text">店铺</div>
                </div>
                <div class="warp-item">
                    <img src="https://mdn.alipayobjects.com/fecodex_image/afts/img/PK2RR43-bWEAAAAAHhAAAAgAejH3AQBr/original"
                        class="content-icon" />
                    <div class="warp-item-text">门头</div>
                </div>
            </div>
              <div class="contact-details">
                <div class="contact-item">
                    <div class="contact-label">手机号：</div>
                    <div class="contact-value">13465832232</div>
                </div>
                <div class="contact-item">
                    <div class="contact-label">地址：</div>
                    <div class="contact-value">地址位于山东省青岛市市北区馆陶路1号6号楼603-8室</div>
                </div>
                <div class="contact-item1">
                    <div class="contact-label">二维码：</div>
                    <div class="contact-qr">
                        <img src="../images/ercode.jpg" alt="微信二维码" @click="showQRCode = true" class="qr-clickable" />
                        <div class="qr-desc">扫码添加微信</div>
                    </div>
                    
                    <!-- 二维码大图弹窗 -->
                    <div v-if="showQRCode" class="qr-modal" @click="showQRCode = false">
                        <div class="qr-modal-content" @click.stop>
                            <img src="../images/ercode.jpg" alt="微信二维码大图" class="qr-large" />
                            <div class="qr-close">点击任意位置关闭</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script setup>
import { ref } from 'vue';

// 控制二维码大图弹窗显示
const showQRCode = ref(false);
</script>

<style scoped>
.contact-img {
    width: 100%;
}

.content {
    border-radius: 12px;
    background-color: #1d1d1d;
    border-color: #101010;
    border-style: solid;
    border-width: 1px;
    margin-top: 28px;
    display: flex;
    flex-direction: column;
    padding: 24px 22px 38px 24px;
}

.content-icon {
    border-radius: 8px;
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    max-width: 100%;
    object-fit: contain;
}

.content-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
}

.warp {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
}

.warp-item {
    display: flex;
    align-items: center;
}

.warp-item-text {
    margin-left: 8px;
    color: #cccccc;
    font-size: 14px;
    margin-left: 10px;
    white-space: nowrap;
}

/* 联系信息区域 */
.contact-info {
    border-radius: 12px;
    background-color: #1d1d1d;
    border-color: #101010;
    border-style: solid;
    border-width: 1px;
    margin-top: 28px;
    display: flex;
    flex-direction: column;
    padding: 24px 22px 38px 24px;
}

.contact-info-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
}

.contact-details {
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;


}

.contact-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-left: 20px;
    justify-content: center;
    align-items: flex-start;
}
.contact-item1{
    display: flex;
    align-items: flex-start;
    
    margin-left: 50px;
}
.contact-item:first-child{
    margin-left: 0;
}
.contact-label {
    font-size: 14px;
    color: #FFFFFF;
    flex-shrink: 0;
}

.contact-value {
    font-size: 14px;
    color: #cccccc;
    flex: 1;
    word-break: break-all;
    overflow-wrap: break-word;
}

.contact-qr {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.contact-qr img {
    width: 140px;
    height: 200px;
    max-width: 100%;
    height: auto;
    margin-top: 10px;
}

.qr-desc {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}

/* 二维码点击样式 */
.qr-clickable {
    cursor: pointer;
    transition: transform 0.2s;
}

.qr-clickable:hover {
    transform: scale(1.05);
}

/* 二维码大图弹窗 */
.qr-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.qr-modal-content {
    background: white;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    max-width: 90vw;
    max-height: 90vh;
    overflow: auto;
}

.qr-large {
    width: 300px;
    height: 300px;
    max-width: 80vw;
    max-height: 80vh;
    width: auto;
    height: auto;
    object-fit: contain;
}

.qr-close {
    margin-top: 15px;
    color: #666;
    font-size: 14px;
}
</style>